import { get, post } from 'pc-sales/utils/http';

export class ArchivesApi {
    // 获取档案信息
    info = (data: { uuid: string; fields?: object }) => get('/v2/client/profile/show', data);

    // 获取用户KYC预设数据
    getPresetKyc = (data: { type?: string[]; uuid: string }) => get('/v2/user/profile/getPresetKyc', data);

    // 创建用户KYC预设数据
    createPresetKyc = (data: { uuid: string; type: string; data: object }) =>
        post('/v2/user/profile/createPresetKyc', data);

    // 更新用户KYC预设数据
    updatePresetKyc = (data: { uuid: string; id: string; data: object }) =>
        post('/v2/user/profile/updatePresetKyc', data);

    // 查询证件真伪检测(当前生效)结果
    spoofListActive = (data: { uuid: string; docType?: string }) => get('/v2/client/poiOcr/listActive', data);
}

export default new ArchivesApi();
